// extracted by mini-css-extract-plugin
export default {"body":"EndSection_body__MepLH"};